import { cn } from '@/app/utils/cn'
import { Dropzone, DropzoneProps } from '@/view/components/Dropzone'
import { Image } from 'lucide-react'
import { useCallback } from 'react'

interface ImageUploadProps extends Omit<DropzoneProps, 'onDrop'> {
  onChange: (files: File[]) => void
  value: File[] | null
}

interface ImageUploadPlaceholderProps {
  className?: string
}

export const ImageUpload = ({ onChange, ...props }: ImageUploadProps) => {
  const onDrop = useCallback(
    (files: File[]) => {
      if (!files.length) return
      onChange([...(props.value ?? []), ...files])
    },
    [onChange, props.value],
  )

  return (
    <Dropzone
      {...props}
      onDrop={onDrop}
      value={props.value ?? null}
      dropzoneOptions={{
        accept: {
          'image/*': ['.jpg', '.jpeg', '.png'],
        },
        maxFiles: 1,
        ...props.dropzoneOptions,
      }}
    />
  )
}

const Placeholder = ({ className }: ImageUploadPlaceholderProps) => {
  return (
    <div
      className={cn(
        'flex h-[103px] w-full flex-col items-center justify-center',
        className,
      )}
    >
      <Image size={48} strokeWidth={1.5} />
      <p className="mt-2 text-xs">
        Arraste e solte ou clique aqui para fazer upload
      </p>
    </div>
  )
}

ImageUpload.Placeholder = Placeholder
